import React, { useState } from "react";
import { Check, Star } from "@mui/icons-material";
import { Skeleton, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ListItem from "@mui/material/ListItem";

interface DashboardOptionProps {
    props: React.HTMLAttributes<HTMLLIElement> & {
        key: any;
    };
    id: string;
    name: string,
    isFavourite: boolean;
    isDefault: boolean;
    isLoading?: boolean;
    onClick?: () => void;
}

const DashboardOption = ({ props, id, name, isFavourite, isDefault, isLoading = false, onClick }: DashboardOptionProps) => {
    const { t } = useTranslation();
    const [textColor, setTextColor] = useState<string>('text.primary');
    const [iconColor, setIconColor] = useState<string>('icon.default');
    const [bgColor, setBgColor] = useState<string>('');

    const isFocusing = (focus: boolean) => {
        if (focus) {
            setTextColor('primary.light');
            setIconColor('primary.light')
            setBgColor('secondary.main')
        } else {
            setTextColor('text.primary');
            setIconColor('icon.default')
            setBgColor('')
        }

    }

    return (isLoading ? (
        <ListItem  sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box  sx={{ display: 'flex', alignItems: 'center', width: '100%', marginLeft: 2 }}>
                <Skeleton  variant="text" width="80%" height={30} sx={{ marginRight: 2 }} />
                <Skeleton  variant="rectangular" width={24} height={24} />
            </Box>
        </ListItem>
    ) : (
        <span id={`span-${id}`} style={{margin: 0, padding: 0, width: '100%', }} {...props}>
        <ListItem  sx={{ display: 'flex', flexDirection: 'row', color: textColor, backgroundColor: bgColor }}
            onMouseOver={() => isFocusing(true)}
            onMouseOut={() => isFocusing(false)}
            onClick={onClick}
        >
            <Typography  sx={{ color: textColor, font: 'opensans', fontSize: '16px', marginRight: 'auto', marginBottom: '12px', marginTop: '12px', textOverflow: 'ellipsis', overflowX: 'hidden'}}>{t(name)}</Typography>
            {isDefault && <Check  aria-label='default-icon' sx={{ marginRight: isFavourite ? '0px' : '42px', marginY: '12px' }} />}
            {isFavourite && <Star  aria-label='favourite-icon' sx={{ color: iconColor, marginLeft: '21px' }} />}
        </ListItem>
        </span>
    ));
}

export default DashboardOption;
